/* FIORE BY FLEUR — interacties, zonder externe libraries */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var stil = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- mobiel menu ---------- */
  function menu() {
    var luik = $('[data-luik]');
    if (!luik) return;
    var zet = function (open) {
      luik.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    $$('[data-luik-open]').forEach(function (b) { b.addEventListener('click', function () { zet(true); }); });
    $$('[data-luik-sluit]').forEach(function (b) { b.addEventListener('click', function () { zet(false); }); });
    $$('a', luik).forEach(function (a) { a.addEventListener('click', function () { zet(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') zet(false); });
  }

  /* ---------- voortgangslijn in de zijkolom ---------- */
  function voortgang() {
    /* een percentage op de wortel: de zijkolom gebruikt het als hoogte,
       de mobiele balk als breedte */
    var wortel = document.documentElement;
    var teken = function () {
      var h = wortel.scrollHeight - window.innerHeight;
      var p = h > 0 ? Math.min(100, Math.max(0, (window.scrollY / h) * 100)) : 0;
      wortel.style.setProperty('--voortgang', p.toFixed(2) + '%');
    };
    window.addEventListener('scroll', teken, { passive: true });
    window.addEventListener('resize', teken);
    teken();
  }

  /* ---------- terug van de formulierdienst ---------- */
  function verzonden() {
    /* De externe verwerker stuurt de bezoeker terug met ?verzonden=1 in het adres.
       Shopify's Liquid kan geen zoekparameters lezen, dus dat gebeurt hier. Daarna
       wordt de parameter uit het adres gehaald, zodat de melding niet opnieuw
       verschijnt als iemand de pagina ververst. */
    if (window.location.search.indexOf('verzonden=1') === -1) return;
    var melding = $('[data-verzonden]');
    if (!melding) return;
    var formulier = melding.closest ? melding.closest('form') : null;
    melding.classList.remove('is-verborgen');
    if (formulier) {
      $$('.veld, button[type=submit]', formulier).forEach(function (el) {
        el.classList.add('is-verborgen');
      });
    }
    melding.scrollIntoView({ block: 'center' });
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname + window.location.hash);
    }
  }

  /* ---------- hoogte van de mobiele balk ---------- */
  function balkhoogte() {
    /* de pagina moet onder de balk beginnen, anders schuift de bovenkant van de
       hero eronder. De balk is zo hoog als het logo plus zijn padding, en dat
       verschilt per lettergrootte, dus meten is betrouwbaarder dan een vast getal. */
    var balk = $('.balk');
    if (!balk) return;
    var meet = function () {
      var h = balk.offsetHeight;
      if (h > 0) document.documentElement.style.setProperty('--balk-hoogte', h + 'px');
    };
    meet();
    window.addEventListener('resize', meet);
    /* het logo is een SVG die soms pas na het laden zijn hoogte krijgt */
    window.addEventListener('load', meet);
  }

  /* ---------- actieve sectie in de navigatie ---------- */
  function scrollspy() {
    var links = $$('[data-spy]');
    if (!links.length || !('IntersectionObserver' in window)) return;

    var kaart = {};
    links.forEach(function (link) {
      var id = link.getAttribute('data-spy');
      var doel = document.getElementById(id);
      if (doel) kaart[id] = link;
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (l) { l.classList.remove('is-actief'); });
        var actief = kaart[e.target.id];
        if (actief) actief.classList.add('is-actief');
      });
    }, { rootMargin: '-45% 0px -50% 0px' });

    Object.keys(kaart).forEach(function (id) { io.observe(document.getElementById(id)); });
  }

  /* ---------- merken-index: beeld volgt de cursor ---------- */
  function merken() {
    /* alle groepen, niet alleen de eerste lijst: kleding, schoenen en
       accessoires staan elk in een eigen <ul data-merken> */
    var rijen = $$('[data-merk-beeld]');
    var metBeeld = rijen.filter(function (r) { return r.getAttribute('data-merk-beeld'); });
    if (!metBeeld.length) return;
    if (window.matchMedia('(hover: none)').matches) return;

    var zweef = document.createElement('div');
    zweef.className = 'zweefbeeld';
    /* twee lagen, zodat het wisselen van merk overvloeit in plaats van springt */
    var lagen = [document.createElement('img'), document.createElement('img')];
    lagen.forEach(function (i) { i.alt = ''; zweef.appendChild(i); });
    lagen[0].className = 'is-boven';
    document.body.appendChild(zweef);

    var doelX = 0, doelY = 0;      // waar de cursor is
    var nuX = 0, nuY = 0;          // waar het beeld staat
    var loopt = false, zichtbaar = false, actief = 0, huidigeBron = '';

    /* de cursor altijd volgen, ook buiten de lijst: zo weten we bij het
       binnenkomen meteen waar het beeld hoort te staan */
    document.addEventListener('mousemove', function (e) {
      doelX = e.clientX;
      doelY = e.clientY;
      if (stil && zichtbaar) zet(doelX, doelY);
    }, { passive: true });

    function zet(x, y) {
      /* de -50% houdt het beeld rond de cursor in plaats van eronder:
         de CSS-transform wordt hier overschreven, dus hij hoort erbij */
      zweef.style.transform =
        'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) translate(-50%,-50%)';
    }

    function animeer() {
      nuX += (doelX - nuX) * 0.16;
      nuY += (doelY - nuY) * 0.16;
      zet(nuX, nuY);
      if (loopt) requestAnimationFrame(animeer);
    }

    function toon(bron) {
      if (bron === huidigeBron) return;
      huidigeBron = bron;
      /* de onzichtbare laag krijgt de nieuwe foto en komt bovenop */
      actief = 1 - actief;
      lagen[actief].src = bron;
      lagen[actief].classList.add('is-boven');
      lagen[1 - actief].classList.remove('is-boven');
    }

    function binnen(bron) {
      toon(bron);
      if (!zichtbaar) {
        /* eerst op de cursor zetten, dán pas laten zien: anders komt het
           beeld vanuit de linkerbovenhoek aangegleden */
        nuX = doelX; nuY = doelY;
        zet(nuX, nuY);
        /* een frame wachten zodat de sprong niet meeanimeert */
        requestAnimationFrame(function () {
          zichtbaar = true;
          zweef.classList.add('is-zichtbaar');
        });
      }
      if (!loopt && !stil) { loopt = true; requestAnimationFrame(animeer); }
    }

    function buiten() {
      zichtbaar = false;
      huidigeBron = '';
      zweef.classList.remove('is-zichtbaar');
      loopt = false;
    }

    rijen.forEach(function (rij) {
      var bron = rij.getAttribute('data-merk-beeld');
      rij.addEventListener('mouseenter', function (e) {
        if (e && e.clientX) { doelX = e.clientX; doelY = e.clientY; }
        /* een merk zonder foto hoort het beeld van het vorige merk weg te halen,
           anders blijft dat hangen en lijkt het bij de verkeerde naam te horen */
        if (bron) { binnen(bron); } else { buiten(); }
      });
    });

    /* verbergen pas als de cursor de hele lijst verlaat, niet bij elke
       overgang van naam naar naam: anders knippert het beeld ertussenin */
    $$('[data-merken]').forEach(function (lijst) {
      lijst.addEventListener('mouseleave', function (e) {
        var naar = e.relatedTarget;
        if (naar && naar.closest && naar.closest('[data-merken]')) return;
        buiten();
      });
    });
    window.addEventListener('blur', buiten);

    /* bij scrollen schuift de lijst onder de cursor door zonder dat de browser
       altijd een mouseleave stuurt. Alleen verbergen als de cursor daardoor
       echt buiten de lijst is beland, niet bij elke scrollbeweging. */
    var scrollWacht = null;
    document.addEventListener('scroll', function () {
      if (!zichtbaar) return;
      clearTimeout(scrollWacht);
      scrollWacht = setTimeout(function () {
        var onder = document.elementFromPoint(doelX, doelY);
        if (!onder || !onder.closest || !onder.closest('[data-merken]')) buiten();
      }, 90);
    }, { passive: true });
  }

  /* ---------- beelden schuiven trager dan de pagina ---------- */
  function parallax() {
    var items = $$('[data-traag]');
    if (!items.length || stil) return;
    var bezig = false;

    function teken() {
      var mid = window.innerHeight / 2;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        var factor = parseFloat(el.getAttribute('data-traag')) || 0.06;
        var afstand = (r.top + r.height / 2 - mid) * factor;
        el.style.transform = 'translate3d(0,' + afstand.toFixed(1) + 'px,0)';
      });
      bezig = false;
    }
    window.addEventListener('scroll', function () {
      if (bezig) return;
      bezig = true;
      requestAnimationFrame(teken);
    }, { passive: true });
    window.addEventListener('resize', teken);
    teken();
  }

  function opkomen() {
    var items = $$('.komt-op, .wipe');
    if (!items.length) return;
    if (stil || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (!e.isIntersecting) return;
        setTimeout(function () { e.target.classList.add('is-in'); }, i * 80);
        io.unobserve(e.target);
      });
    }, {
      rootMargin: '0px 0px -12% 0px',
      /* drempel 0: een element dat zichzelf wegsnijdt met clip-path heeft
         oppervlakte 0 en zou bij een hogere drempel nooit verschijnen */
      threshold: 0
    });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- het gordijn maar één keer per bezoek ---------- */
  function gordijn() {
    var vlak = $('[data-gordijn]');
    if (!vlak) return;
    var sleutel = 'fiore-gordijn';
    var gezien = false;
    try { gezien = sessionStorage.getItem(sleutel) === '1'; } catch (e) {}
    if (gezien) {
      vlak.classList.add('gordijn--weg');
      return;
    }
    try { sessionStorage.setItem(sleutel, '1'); } catch (e) {}
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      document.body.style.overflow = '';
      if (vlak.parentNode) vlak.parentNode.removeChild(vlak);
    }, stil ? 100 : 2900);
  }

  function start() {
    gordijn();
    menu();
    voortgang();
    verzonden();
    balkhoogte();
    scrollspy();
    merken();
    opkomen();
    parallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
